import { Avatar } from 'antd'
import type { CSSProperties } from 'react'

const COLOR_CLASSNAMES = ['bg-blue-500', 'bg-yellow-400', 'bg-red-400', 'bg-green-400', 'bg-purple-400']

export const UserAvatar = ({
  name,
  imageUrl,
  size,
  style,
}: {
  name: string
  imageUrl: string
  size?: 'small' | 'default' | 'large'
  style?: CSSProperties
}) => {
  if (imageUrl !== '') {
    return <Avatar size={size ?? 'default'} shape="circle" src={imageUrl} style={{ ...style }} />
  }
  const colorSeed = name.split('').reduce((accumulator, x) => accumulator + x.charCodeAt(0), 0)
  const color = COLOR_CLASSNAMES[colorSeed % COLOR_CLASSNAMES.length]
  return (
    <Avatar size={size ?? 'default'} shape="circle" className={color} style={{ marginRight: 0 }}>
      {name[0] ?? '?'}
    </Avatar>
  )
}
